import { apiFetch, appConfig, formatDateWithTime, Spinner } from '@ami/react/core';
import PropTypes from 'prop-types';
import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Alert, Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { isUserAuthorizedToAcceptQuotesInDealerBranch } from '../../../authorization/permissions';
import { orderNumberPipe } from "../../../orderNumberPipe";
import QuoteView from '../../../quotes/view/quoteView';
import QuoteAcceptanceInformationModalComponent from './QuoteAcceptanceInformationModalComponent';

class StatusComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showAcceptModal: false,
      downloading: false
    };
    this.handleShowAcceptModal = this.handleShowAcceptModal.bind(this);
    this.handleHideAcceptModal = this.handleHideAcceptModal.bind(this);
  }

  static propTypes = {
    quote: PropTypes.instanceOf(QuoteView).isRequired,
    refreshQuote: PropTypes.func.isRequired,
  };
  handleShowAcceptModal() {
    this.setState({ showAcceptModal: true });
  }

  handleHideAcceptModal() {
    this.setState({ showAcceptModal: false });
  }

  downloadDocument = async (quoteId) => {
    this.setState({ downloading: true });
    const response = await apiFetch(`quotes/${quoteId}/purchase-order`);
    window.location = response.url;
    this.setState({ downloading: false });
  };

  navigateToCreateOrder(quoteId, isBlackbirdOrder) {
    const url = isBlackbirdOrder ? `/orders/create?quoteId=${quoteId}&isBlackbirdOrder=${isBlackbirdOrder}`
      : `/orders/create?quoteId=${quoteId}`;
    this.props.history.push(url);
  }

  async componentDidMount() {
    const { dealerInformation } = this.props.quote;
    const canAccept = isUserAuthorizedToAcceptQuotesInDealerBranch(
      dealerInformation.dealerGroupId,
      dealerInformation.dealerBranchId
    );
    this.setState({ canAccept });
  }

  render() {
    const { quote, refreshQuote } = this.props;
    const { statusInformation, preventPoSubmissionByTask } = quote;
    return (
      <div className="card mb-3 box-shadow quote-status flex-fill">
        <div className="card-body">
          <h6 className="card-title text-center">Purchase Order</h6>
          {statusInformation.machineAndModelMissing && (
            <div>
              <div className="alert alert-danger mb-1" role="alert">
                <i className="fa fa-exclamation-circle" /> Machine make/model is
                missing
              </div>
            </div>
          )}
          {statusInformation.anyCouplerDecisionNotSpecified && (
            <div>
              <div className="alert alert-danger mb-1" role="alert">
                <i className="fa fa-exclamation-circle" /> Lugging style is
                missing
              </div>
            </div>
          )}
          {statusInformation.thumbBucketSpecificationsMissing && (
            <div>
              <div className="alert alert-danger mb-1" role="alert">
                <i className="fa fa-exclamation-circle" /> Thumb bucket
                specifications are missing
              </div>
            </div>
          )}
          {statusInformation.machineRequiresApproval && (
            <div>
              <div className="alert alert-danger mb-1" role="alert">
                <i className="fa fa-exclamation-circle" /> Machine approval
                required
              </div>
            </div>
          )}
          {statusInformation.missingDiscountDocumentation &&
            statusInformation.discountNames.map((item, i) => (
              <div key={i}>
                <div className="alert alert-danger mb-1" role="alert">
                  <i className="fa fa-exclamation-circle" /> {item} documentation is
                  missing
                </div>
              </div>
            ))}
          {statusInformation.isPending && this.state.canAccept && (
            <div>
              {preventPoSubmissionByTask && (
                <Alert color="danger" className="w-100">
                  <div className='row'>
                    <div className='col-12 d-flex align-items-center'>
                      <div className='flex-grow-0 me-2'>
                        <i className="fa fa-exclamation-circle" />
                      </div>
                      <div className='flex-grow-0'>
                        This quote needs to be approved by an AMI Salesperson before a PO can be submitted.
                      </div>
                    </div>
                  </div>
                </Alert>
              )}
              <button
                type="button"
                className={`btn btn-lg btn-block mt-3 ${statusInformation.readyForPurchaseOrderSubmission && !(preventPoSubmissionByTask)
                  ? 'btn-success'
                  : 'btn-secondary'
                  }`}
                onClick={() => this.handleShowAcceptModal()}
                disabled={!statusInformation.readyForPurchaseOrderSubmission || (preventPoSubmissionByTask)}
              >
                Submit Purchase Order
              </button>
            </div>
          )}
          {statusInformation.isPending && !this.state.canAccept && (
            <div>
              <div>Pending Purchase Order</div>
              <div>
                <em>Only authorized users can submit a purchase order</em>
              </div>
            </div>
          )}
          {(statusInformation.isAccepted || statusInformation.isCompleted) && (
            <div>
              {quote.relatedOrders.length > 0 && (
                <div className="row mt-3">
                  <div className="col">
                    {quote.relatedOrders.map((o) => (
                      <Link
                        className="btn btn-lg btn-block btn-success"
                        key={o.orderNumber}
                        to={`/orders/view/${o.orderId}`}
                      >
                        View Order {orderNumberPipe(o.orderId)}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
              <div className="row mt-3">
                <label className="col-sm-4 d-flex align-items-center">
                  PO Number
                </label>
                <div className="col-sm-8">
                  <div className="flextable">
                    <div className="flextable-item flextable-primary">
                      {quote.acceptance.poNumber}
                    </div>
                    <div className="flextable-item">
                      {quote.acceptance.hasAttachment && (
                        <Button
                          color="outline-primary"
                          className="btn-sm"
                          onClick={() => this.downloadDocument(quote.id)}
                        >
                          <span className="fa fa-download" />
                          <Spinner show={this.state.downloading} />
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <label className="col-sm-4">Submitted On</label>
                <div className="col-sm-8">
                  {formatDateWithTime(quote.acceptance.acceptedDate)}
                </div>
              </div>
              <div className="row">
                <label className="col-sm-4">Submitted By</label>
                <div className="col-sm-8">{quote.acceptance.acceptedBy}</div>
              </div>
              <div className="row">
                <label className="col-sm-4">Notes</label>
                <div className="col-sm-8">
                  {quote.acceptance.notes || 'N/A'}
                </div>
              </div>
              {!quote.orderId && (
                <div className="row mt-3">
                  <div className="col">
                    <Link
                      to=""
                      onClick={(e) => {
                        e.preventDefault();
                        this.handleShowAcceptModal();
                      }}
                    >
                      Edit Information
                    </Link>
                  </div>
                </div>
              )}
              {appConfig.isManagementApp &&
                quote.relatedOrders.length === 0 && (
                  <React.Fragment>
                    {!statusInformation.readyForOrder &&
                      statusInformation.machineRequiresOemPinUp && (
                        <div>
                          <div className="alert alert-danger" role="alert">
                            <i className="fa fa-exclamation-circle" /> Machine
                            OEM pin up required
                          </div>
                        </div>
                      )}

                    <div className="row mt-3">
                      <div className="col">
                        {/* <UncontrolledDropdown group>
                          <Button color={`btn  btn-lg  ${statusInformation.readyForOrder
                            ? 'btn-success'
                            : 'btn-secondary'
                            }`} onClick={() => this.navigateToCreateOrder(this.props.quote.id, true)}>
                            Convert to Order
                          </Button>
                          <DropdownToggle
                            caret
                            color={`btn btn-lg  ${statusInformation.readyForOrder
                              ? 'btn-success'
                              : 'btn-secondary'
                              }`}
                          />
                          <DropdownMenu>
                            <DropdownItem onClick={() => this.navigateToCreateOrder(this.props.quote.id, true)}>
                              Blackbird Managed Order (Default)
                            </DropdownItem>
                            <DropdownItem onClick={() => this.navigateToCreateOrder(this.props.quote.id)}>
                              JobBoss Managed Order
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown> */}

                        <button
                          type="button"
                          className={`btn btn-lg btn-block ${statusInformation.readyForOrder
                            ? 'btn-success'
                            : 'btn-secondary'
                            }`}
                          onClick={() =>
                            this.navigateToCreateOrder(this.props.quote.id)
                          }
                          disabled={!statusInformation.readyForOrder}
                        >
                          Convert to Order
                        </button>
                      </div>
                    </div>
                  </React.Fragment>
                )}
            </div>
          )}
          {statusInformation.isCancelled && (
            <div>
              <div className="alert alert-danger" role="alert">
                <i className="fa fa-exclamation-circle" /> This quote has been
                cancelled
              </div>
            </div>
          )}
          {statusInformation.isExpired && (
            <div>
              <div className="alert alert-danger" role="alert">
                <i className="fa fa-exclamation-circle" /> This quote has been
                expired
              </div>
            </div>
          )}
        </div>
        <QuoteAcceptanceInformationModalComponent
          quote={quote}
          refreshQuote={refreshQuote}
          showModal={this.state.showAcceptModal}
          hideModal={this.handleHideAcceptModal}
          isEditMode={statusInformation.isAccepted}
        />
      </div>
    );
  }
}

export default withRouter(StatusComponent);
